import PropTypes from 'prop-types'
import React from 'react'
import { formatDate } from '../../../common/utils'
import Img from '../Img'

const Author = ({ img, date, title, jobPosition, url }) => (
  <div className="my-3 flex items-center px-2 lg:px-0">
    <div className="pr-2 md:mx-0">
      <Img
        src={img || '/next-assets/avatar.webp'}
        alt="Hero"
        className="h-8 w-8 overflow-hidden rounded-full"
        styles={{ position: 'relative' }}
      />
    </div>
    <div>
      <a
        href={url}
        aria-label="title"
        className="cursor-pointer text-xs font-bold text-gray-510 hover:text-blue-700"
      >
        {title || ''}
      </a>
      {jobPosition && title && (
        <span
          data-testid="job-position"
          className="text-xs font-normal text-gray-245"
        >
          {` / ${jobPosition}`}
        </span>
      )}
      <p data-testid="date" className="text-xs font-normal text-gray-510">
        {formatDate(date)}
      </p>
    </div>
  </div>
)

Author.defaultProps = {
  img: '',
  date: undefined,
  title: '',
  jobPosition: '',
  url: '',
}

Author.propTypes = {
  img: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  title: PropTypes.string,
  jobPosition: PropTypes.string,
  url: PropTypes.string,
}
export default Author
